import ItemsDisplayPage from './items-display-page.component';
import { connect } from 'react-redux';
import { State } from 'widgets/redeem/root/root.reducers';
import { IItemsDisplayPageDispatchProps, IItemsDisplayPageStateProps } from './items-display-page.types';
import { Dispatch } from 'types/dispatch';
import { selectGameItem } from '../pyc-redeem.actions';

const mapStateToProps = (state: State): IItemsDisplayPageStateProps => ({
    contentGameItems: state.PYCRedeemReducer.contentGameItems,
});

const mapDispatchToProps = (dispatch: Dispatch): IItemsDisplayPageDispatchProps => ({
    selectGameItem: (actionId: string): void => {
        dispatch(selectGameItem(actionId));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemsDisplayPage);
